/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";


import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import SaveRoundButton from "../../framework/forms/helpercomponents/buttons/SaveRoundButton";
import CancelRoundButton from "../../framework/forms/helpercomponents/buttons/CancelRoundButton";

import { utility } from "../../framework/utility/utilityProvider";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import BossDialog from "../../components/BossDialog";
import ToastNotification from "../../components/ToastNotification";

export const CopySlotPrototypeEditForm = (props) => {
  const loc = useLocation();
  const navigate = useNavigate();
  const lang = useTranslation();

  const [dataItem, setDataItem] = useState({
    SID: props.item?.SID ?? SID,
    Description: props.item?.copy ? 'Copy of ' + props.item.Description : props.item?.Description ?? '',
    DayBuffer: '',
    SlotStartTime: '00:00:00:00',
    Archive: props.item?.Archive ?? false,
    index: null
  });

  const [slotsData, setSlotsData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (props?.item?.SID > 0) loadEditData();
  }, []);

  const loadEditData = async () => {
    let res = await API.getEntity(ENTITYNAME.CopySlotPrototype, parseInt(props.item.SID));
    if (res.success) {
      const formattedSlots = (res.data.Slots || []).map((item, i) => ({
        DayBuffer: item.DayBuffer,
        SlotStartTime: utility.convertMilisecondsToStringWithFrames(item.SlotStartTime),
        index: i
      }));
      setDataItem(prev => ({...prev, Description: res.data.Description }));
      setSlotsData(formattedSlots);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setDataItem(prev => ({ ...prev, [name]: value }));
  };

  const addSlot = () => {
    if (!dataItem.DayBuffer || !dataItem.SlotStartTime) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_fill_daybuffer_and_slot_error_message });
      return;
    }
  
  const isDuplicate = slotsData.some(item =>
      item.DayBuffer === dataItem.DayBuffer &&
      item.SlotStartTime === dataItem.SlotStartTime
    );
    if (isDuplicate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.duplicate_daybuffer_slot_error_message });
      return;
    }
    const newSlot = {
      DayBuffer: dataItem.DayBuffer,
      SlotStartTime: dataItem.SlotStartTime,
      index: Date.now()
    };

    setSlotsData(prev => [...prev, newSlot]);
    clearForm();
  };

  const editFormGrid = (data) => {
    const item = data.dataItem;
    setDataItem(prev => ({
      ...prev,
      DayBuffer: item.DayBuffer,
      SlotStartTime: item.SlotStartTime,
      index: item.index
    }));

    setShowForm(true);
    setEditMode(true);
  };

  const updateSlot = () => {
    if (!dataItem.DayBuffer || !dataItem.SlotStartTime) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_fill_daybuffer_and_slot_error_message });
      return;
    }
    const isDuplicate = slotsData.some(item =>
      item.DayBuffer === dataItem.DayBuffer &&
      utility.convertStringWithFramesToMilliseconds(item.SlotStartTime) === utility.convertStringWithFramesToMilliseconds(dataItem.SlotStartTime)
    );

    if (isDuplicate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.duplicate_daybuffer_slot_error_message });
      return;
    }
    setSlotsData(prev =>
      prev.map(item =>
        item.index === dataItem.index ? {
          ...item,
          DayBuffer: dataItem.DayBuffer,
          SlotStartTime: dataItem.SlotStartTime
        } : item
      )
    );
    clearForm();
  };

  const removeSlotItem = (index) => {
    setSlotsData(prev => prev.filter(item => item.index !== index));
    clearForm();
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message});
  };

  const clearForm = () => {
    setDataItem(prev => ({
      ...prev,
      DayBuffer: '',
      SlotStartTime: '',
      index: null
    }));
    setEditMode(false);
    setShowForm(false);
  };

  const onSave = async () => {

    if (!dataItem.Description) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
      return;
    }

    if(slotsData.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_add_atleast_one_slot_error_message });
      return;
    }

    if(showForm){
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_complete_save_changes_error_message });
      return;
    }

    const saveData = {
      SID: loc.state?.copy ? 0 : dataItem.SID,
      Description: dataItem.Description,
      Archive: dataItem.Archive ?? false,
      Slots: slotsData.map(item => ({
        DayBuffer: item.DayBuffer,
        SlotStartTime: utility.convertStringWithFramesToMilliseconds(
          item.SlotStartTime.toString()
        )
      }))
    };

    let res = await API.saveData(ENTITYNAME.CopySlotPrototype, saveData);

    if (res.success) {
      API.SaveLogs({
        event: res.message === "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT,
        module: MODULE.COPY_SLOT_PROTOTYPE,
        data: res.data,
        message: res.message
      });
      onClose();      
      utility.deleteLocalStorageItem(ENTITYNAME.CopySlotPrototype);
      console.log("calling refresh...");
      props.refresh();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };

  const onClose = () => {
    props.cancelEdit ? props.cancelEdit() : navigate(-1);
  };



  const labelStyle = {
    fontSize: '13px',
    fontWeight: 500,
    color: '#333',
    marginBottom: '4px',
  };

  return (
    <BossDialog
      title={lang.copy_slot_prototype_sub_menu}
      onClose={onClose}
      width={"600px"}
    >
      <EditPageHeader onSubmit={onSave} onCancel={props.cancelEdit} showTitle={false} />

      {/* Description & Archive */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '8px' }}>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>{lang.description_label} <span style={{ color: '#ef4444' }}>*</span></label>
          <input
            type="text"
            className="form-control form-control-sm"
            name="Description"
            value={dataItem.Description}
            onChange={onChange}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', paddingTop: '20px' }}>
          <input
            type="checkbox"
            id="archiveCheck"
            checked={dataItem.Archive}
            onChange={(e) =>
              setDataItem({ ...dataItem, Archive: e.target.checked })
            }
          />
          <label htmlFor="archiveCheck" style={{ fontSize: '13px', color: '#333', cursor: 'pointer', marginBottom: 0 }}>{lang.archive}</label>
        </div>
      </div>

      {/* Add Button / Inline Add-Edit Row */}
      {!showForm ? (
        <div style={{ marginTop: '14px' }}>
          <AddRoundButton onClick={() => { setShowForm(true); setDataItem(prev => ({ ...prev, SlotStartTime: '00:00:00:00' })); }} />
        </div>
      ) : (
        <div style={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: '12px',
          marginTop: '14px',
          padding: '12px 14px',
          background: '#f8fafc',
          borderRadius: '8px',
          border: '1px solid #e2e8f0',
        }}>
          <div style={{ width: '100px' }}>
            <label style={labelStyle}>{lang.day_buffer_label}</label>
            <input
              type="number"
              className="form-control form-control-sm"
              name="DayBuffer"
              value={dataItem.DayBuffer}
              onChange={onChange}
              style={{ textAlign: 'center' }}
              min={1}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>{lang.slot_start_time}</label>
            <TimePickerWithFormat
              name="SlotStartTime"
              value={dataItem.SlotStartTime}
              onChange={onChange}
            />
          </div>
          <div style={{ display: 'flex', gap: '4px', paddingBottom: '1px' }}>
            {!editMode
              ? <AddRoundButton onClick={addSlot} />
              : <SaveRoundButton onClick={updateSlot} />
            }
            <CancelRoundButton onClick={clearForm} />
          </div>
        </div>
      )}

      {/* Slots Table */}
      <div style={{ marginTop: '12px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ background: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                <th style={{ padding: '9px 12px', textAlign: 'center', fontWeight: 600, color: '#475569', borderBottom: '2px solid #e2e8f0', width: '70px' }}></th>
                <th style={{ padding: '9px 12px', textAlign: 'center', fontWeight: 600, color: '#475569', borderBottom: '2px solid #e2e8f0', width: '110px' }}>{lang.day_buffer_column}</th>
                <th style={{ padding: '9px 12px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '2px solid #e2e8f0' }}>{lang.slot_start_time_column}</th>
              </tr>
            </thead>
            <tbody>
              {slotsData.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ padding: '30px 0', textAlign: 'center', color: '#94a3b8', fontSize: '13px' }}>
                    <i className="fa fa-inbox" style={{ fontSize: '20px', display: 'block', marginBottom: '6px' }} />
                    No slots added yet
                  </td>
                </tr>
              ) : (
                slotsData.map((item, idx) => (
                  <tr
                    key={item.index}
                    style={{
                      borderBottom: '1px solid #f1f5f9',
                      background: dataItem.index === item.index ? '#eff6ff' : (idx % 2 === 0 ? '#fff' : '#fafbfc'),
                      transition: 'background 0.15s',
                    }}
                    onMouseEnter={(e) => { if (dataItem.index !== item.index) e.currentTarget.style.background = '#f1f5f9'; }}
                    onMouseLeave={(e) => { if (dataItem.index !== item.index) e.currentTarget.style.background = idx % 2 === 0 ? '#fff' : '#fafbfc'; }}
                  >
                    <td style={{ padding: '6px 8px', textAlign: 'center' }}>
                      <div style={{ display: 'flex', justifyContent: 'center', gap: '2px' }}>
                        <button
                          type="button"
                          onClick={() => editFormGrid({ dataItem: item })}
                          style={{
                            border: 'none', background: 'transparent', cursor: 'pointer',
                            color: '#3b82f6', fontSize: '13px', padding: '4px 6px', borderRadius: '4px',
                            transition: 'background 0.15s',
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = '#dbeafe'}
                          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                          title="Edit"
                        >
                          <i className="fa fa-pencil" />
                        </button>
                        <button
                          type="button"
                          onClick={() => ConfirmDeleteAlert(() => removeSlotItem(item.index), () => { })}
                          style={{
                            border: 'none', background: 'transparent', cursor: 'pointer',
                            color: '#ef4444', fontSize: '13px', padding: '4px 6px', borderRadius: '4px',
                            transition: 'background 0.15s',
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = '#fee2e2'}
                          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                          title="Delete"
                        >
                          <i className="fa fa-trash" />
                        </button>
                      </div>
                    </td>
                    <td style={{ padding: '9px 12px', textAlign: 'center', fontWeight: 500, color: '#1e293b' }}>{item.DayBuffer}</td>
                    <td style={{ padding: '9px 12px', color: '#334155' }}>{item.SlotStartTime}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </BossDialog>
  );
};

export default CopySlotPrototypeEditForm;